<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined :useBtnList="[
                                        'btnRetrieve', //Retrieve
                                        'btnSaveExcel'   //Save Excel
                                    ]" @btnRetrieve="btnRetrieve()" @btnSaveExcel="onExporting()">
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-0">
                                                    <i-label :label="'Period : '" />
                                                    <v-col cols="2">
                                                        <DxDateBox :value="startDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                                                    </v-col>
                                                    <span class="pa-1 subTitle"> ~ </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="endDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                                                    </v-col>                                                   
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" align="right" class="pr-2 vat">(V.A.T Separate)</v-col>
                                    </v-row>
                                    <DxDataGrid id="epms5050" class="listBox" :ref="epms5050Ref"
                                        :data-source="gridMainList" 
                                        :remote-operations="false" 
                                        :hover-state-enabled="true"
                                        :allow-column-resizing="true" 
                                        :allow-column-reordering="true"
                                        :row-alternation-enabled="true" 
                                        :show-borders="true" 
                                        :width="grid.width"
                                        :show-row-lines="true" 
                                        key-expr="id" 
                                        :focused-row-enabled="true"
                                        :column-hiding-enabled="false" 
                                        :selection="{ mode: 'none' }"
                                        @cellPrepared="cellPrepared"
                                        @exporting="onExporting" >
                                        <DxExport :enabled="true" />
                                        <DxEditing :allow-updating="true"                                                                                                          
                                            mode="cell" />
                                        
                                        <DxColumn data-field="whDte" caption="W/H Date" width="10%" data-type="date" format="yyyy-MM-dd"
                                                alignment="center" :allow-editing="false" />
                                        <DxColumn data-field="seq" caption="Seq" width="5%" data-type="string"
                                                alignment="center" :allow-editing="false" />
                                        <DxColumn data-field="shipNo" caption="Ship no" width="8%" data-type="string"
                                                alignment="center" :allow-editing="false" />
                                        <DxColumn data-field="porNo" caption="Por no" width="12%" data-type="string"
                                                    alignment="center" :allow-editing="false" />
                                        <DxColumn data-field="porSeq" caption="Por seq" width="7%" data-type="string"
                                                    alignment="center" :allow-editing="false" :visible="false"/>
                                         <DxColumn data-field="poNo" caption="Po no" width="15%" data-type="string"
                                                        alignment="center" :allow-editing="false" />
                                         <DxColumn data-field="matlCd" caption="Material Code" width="12%" data-type="string"
                                                            alignment="center" :allow-editing="false" />
                                         <DxColumn data-field="partNo" caption="Part No" width="10%" data-type="string"
                                                                alignment="center" :allow-editing="false" />  
                                        <DxColumn data-field="partSpec" caption="Part Specification" width="30%" data-type="string"
                                                                    alignment="left" :allow-editing="false" />   
                                        <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string"
                                                                    alignment="center" :allow-editing="false" />                                                       
                                        <DxColumn data-field="whQty" caption="Qty" width="8%" data-type="number" format="#,###"
                                                                        alignment="center" :allow-editing="false" />  
                                        <DxColumn data-field="partUnitWgt" caption="Weight" width="10%" data-type="number" format="#,###.###"
                                                                            alignment="center" :allow-editing="false" /> 
                                        <DxColumn data-field="uprice" caption="Unit Price" width="8%" data-type="number" format="#,###"
                                                                            alignment="right" :allow-editing="false" /> 
                                         <template #h_uprice>
                                                <div>Unit<br/>Price</div>
                                            </template> 
                                        <DxColumn data-field="whAmt" caption="W/H Amount" width="12%" data-type="number" format="#,###"
                                                                                alignment="right" :allow-editing="false" header-cell-template="h_whAmt"/>   
                                        <template #h_whAmt>
                                            <div>W/H<br/>Amount</div>
                                        </template>
                                        <DxColumn data-field="vatAmt" caption="W/H VAT" width="7%" data-type="number" format="#,###"
                                                                                    alignment="right" :allow-editing="false" header-cell-template="h_whVAT"/>   
                                        <template #h_whVAT>
                                                <div>W/H<br/>VAT</div>
                                            </template>                                                  
                                        <DxColumn data-field="transFee" caption="Trans.Fee" width="7%" data-type="number" format="#,###"
                                                                                        alignment="right" :allow-editing="false" header-cell-template="h_transFee"/>  
                                         <template #h_transFee>
                                                    <div>Trans.<br/>Fee</div>
                                                </template>                                                                                                                                          
                                        <DxColumn data-field="vatTransFee" caption="Trans.VAT" width="7%" data-type="number" format="#,###"
                                                                                            alignment="right" :allow-editing="false" header-cell-template="h_transVAT"/>   
                                         <template #h_transVAT>
                                                    <div>Trans.<br/>VAT</div>
                                                </template>                                                                                                                                                                                                                                
                                        <DxColumn data-field="govFee" caption="Gov.Fee" width="7%" data-type="number" format="#,###"
                                                                                                alignment="right" :allow-editing="false" header-cell-template="h_govFee"/>  
                                         <template #h_govFee >
                                                        <div>Gov.<br/>Fee</div>
                                                    </template>                                                    
                                         <DxColumn data-field="totAmt" caption="Total Amount" width="12%" data-type="number" format="#,###"
                                                                                                    alignment="right" :allow-editing="false" cell-template= "ttAmtTemplate"/>                                                    
                                         <template #ttAmtTemplate="{ data }">
                                                        <div style="color:blue">{{ data.text }}</div>
                                                    </template>
                                        <DxPaging :enabled="true" :page-size="16" />
                                         <DxSummary>
                                                <DxTotalItem column="whDte" summary-type="sum" display-format="Total"
                                                    alignment="center" />
                                                <DxTotalItem column="whQty" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="partUnitWgt" summary-type="sum" :customize-text="formatLength" />                                               
                                                <DxTotalItem column="whAmt" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="vatAmt" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="transFee" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="vatTransFee" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="govFee" summary-type="sum" :customize-text="formatPrice" />
                                                <DxTotalItem column="totAmt" summary-type="sum" :customize-text="formatPrice" />
                                            </DxSummary>
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxSummary, DxTotalItem, DxButton, DxExport, DxPaging } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate, getPreMonth, getFirstDay } from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { epms5050List } from '@/api/view/hip/5/epms5050.js'
import { reportView } from '@/api/view/hip/common/common.js'
import { getNumComma } from '@/utils/common.js'

export default {
    name: 'epms5050',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDataGrid,
        DxColumn,
        DxDateBox,
        DxButton,
        DxExport,
        DxTotalItem,
        DxEditing,
        DxSummary,
        DxButton,
        DxPaging

    },
    data() {
        return {
            menuTitle: this.$route.meta.title,
            startDate: '',
            endDate: '',

            epms5050Ref: 'epms5050Ref',                       
            stDte: '',
            edDte: '',
            gridMainList:[]
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms5050Ref)
        },
    },
    mounted() {
       
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        
        this.doSearchMain()
    },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(data) {            
            return getNumComma(data.value)
        },
         formatLength(data) {
            let num = data.value.toFixed(3)
            return getNumComma(num)
        },
       
        btnRetrieve() {           
            this.doSearchMain()
        },
        async doSearchMain() {
            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,               
                stDte: this.stDte,
                edDte: this.edDte
            }
            await epms5050List(params).then(res => {    
                 res.list.forEach(e => {
                    e.id = e.rnum
                });           
                this.gridMainList = res.list
            }).finally(() => {
                this.endLoading()
            })

        },       
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Warehousing By Period');

            exportDataGrid({
                component: this.gridMainInstance,
                worksheet,
                topLeftCell: { row: 1, column: 1 },
            }).then((cellRange) => {
                const headerRow = worksheet.getRow(1);
                const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
                const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: { style: 'thin', fgColor: { argb: 'bfbfbf' } } }
                let headerRowLength = headerRow._cells.length
                for (let i = 1; i <= headerRowLength; i++) {
                    headerRow.getCell(i).fill = headerStyle
                    headerRow.getCell(i).border = headerBorderStyle
                    headerRow.getCell(i).alignment = { horizontal: 'center' }
                }
                for (let j = 2; j <= worksheet._rows.length; j++) {
                    for (let a = 1; a <= worksheet.getRow(j)._cells.length; a++) {
                        worksheet.getRow(j).getCell(a).border = headerBorderStyle
                    }
                }
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'WarehousingByPeriod.xlsx');
                });
            });
            this.gridMainInstance.cancel = true;
        },

        cellPrepared(e) {
             if (e.rowType === 'totalFooter') {
               // e.cellElement.style.fontSize = '11px'
                if (e.column.name === 'whDte' || e.column.name === 'whQty' || e.column.name === 'partUnitWgt' || e.column.name === 'whAmt' || e.column.name === 'vatAmt' ||
                    e.column.name === 'uprice' || e.column.name === 'transFee' || e.column.name === 'vatTransFee' || e.column.name === 'govFee' || e.column.name === 'totAmt') {
                    e.cellElement.style.borderRight = '1px solid gray'
                }
                if (e.columnIndex == '0') {
                    e.cellElement.setAttribute('colspan', 9)
                } else if (e.columnIndex > '0' && e.columnIndex < '9') {
                    e.cellElement.style.display = 'none'
                }
             } else if (e.rowType === 'header') {
                 if (e.column.caption === 'Total Amount') {
                    e.cellElement.style.color = '#0000CC'
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.subTitle {
    font-weight: bold;
    color: black;
}

.vat {
    color: blue;
}

</style>